import React from 'react'

import { InfoIcon } from '../../icons/line'
import { Icon } from '../icon'
import { Pressable } from '../pressable'
import { Tooltip, TooltipContent, TooltipText } from '../tooltip'

export type PredictionNotAvailableProps = {
    reason: string
    testID?: string
}

/**
 * The `reason-icon (prediction not available)` that `KpiDirection` shows with
 * `noPrediction`. Figma keeps the node hidden in every variant, so the dump has
 * no binding for it and the contract cannot carry it: the ink and the 16px size
 * are the ones the component description states — see DESIGN-TODO.
 */
export const PredictionNotAvailable = ({
    reason,
    testID = 'prediction-not-available',
}: PredictionNotAvailableProps) => (
    <Tooltip
        trigger={triggerProps => (
            <Pressable
                {...triggerProps}
                onHoverIn={triggerProps.onMouseEnter}
                onHoverOut={triggerProps.onMouseLeave}
                accessibilityLabel={reason}
                className='shrink-0 web:pointer-events-auto web:cursor-default'
                testID={testID}
            >
                <Icon as={InfoIcon} size='sm' className='text-content-muted' />
            </Pressable>
        )}
    >
        <TooltipContent>
            <TooltipText>{reason}</TooltipText>
        </TooltipContent>
    </Tooltip>
)

PredictionNotAvailable.displayName = 'PredictionNotAvailable'
